import { useCallback } from "react"

import { useTranslation } from "react-i18next"

import { useAIExplorerSettings } from "@/hooks/use-module-settings"

import { CategoryPicker } from "./category-picker"

type CategoryFilterProps = {
  sessionType: string
  libraryId: string
  variant?: "sidebar" | "footer"
}

export function CategoryFilter({
  sessionType,
  libraryId,
  variant = "sidebar",
}: CategoryFilterProps) {
  const { t } = useTranslation()
  const { settings, updateSettings } = useAIExplorerSettings(sessionType)
  const selectedCategories = settings?.selected_categories || []

  const handleCategoryChange = useCallback(
    (categories: string[]) => {
      updateSettings({ selected_categories: categories })
    },
    [updateSettings]
  )

  if (variant === "footer") {
    return (
      <CategoryPicker
        activeCategories={selectedCategories}
        libraryId={libraryId}
        popoverSide="top"
        triggerLabel={t("libraries.categories")}
        triggerVariant="footer"
        onCategoryChange={handleCategoryChange}
      />
    )
  }

  return (
    <div className="flex flex-col gap-3">
      <span className="text-muted-foreground text-xs font-semibold tracking-wider uppercase">
        {t("libraries.categories")}
      </span>
      <CategoryPicker
        activeCategories={selectedCategories}
        libraryId={libraryId}
        onCategoryChange={handleCategoryChange}
      />
    </div>
  )
}
